/**
 * @file Canonical category order for sorting device lists.
 *
 * Used by /me, /people/:id and anywhere else we render a vertical list of
 * an employee's gear. Laptops first (always the headline item), then
 * phones, then peripherals roughly by cost, then ancillary items.
 *
 * Lifted out of /me + /people/:id where it had drifted into two
 * identical-but-separate copies.
 */

export const CATEGORY_ORDER = Object.freeze([
  'laptop',
  'phone',
  'ext_screen',
  'keyboard',
  'mouse',
  'charger',
  'access_card',
  'ai_tool',
  'multisport',
  'phone_tariff',
  'other',
]);

/**
 * Numeric rank for sorting. Unknown categories sort to the end.
 */
export function catRank(category) {
  const i = CATEGORY_ORDER.indexOf(category);
  return i === -1 ? CATEGORY_ORDER.length : i;
}
